import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CreateTipoMonedaRequest } from '@models/tipo-moneda/createTipoMonedaRequest.model';
import { TipoMonedaDto } from '@models/tipo-moneda/tipoMonedaDto.model';
import { UpdateTipoMonedaRequest } from '@models/tipo-moneda/updateTipoMonedaRequest.model';
import { isFalsy } from 'utility-types';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { BaseDto } from '@models/base/baseDto.model';

@Injectable({
  providedIn: 'root'
})
export class TiposPropiedadService {

  private id!: number;

  set setId(id:number) {
    this.id = id;
  }

  get getId() {
    return this.id;
  }

  constructor(
    private http: HttpClient
  ) { }

  create(createKeyValueRequest:CreateKeyValueRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/TiposPropiedad/Create",createKeyValueRequest);
  }

  update(updateKeyValueRequest:UpdateKeyValueRequest):Observable<any>
  {
    return  this.http.put<any>("/api/TiposPropiedad/Update",updateKeyValueRequest);
  }

  getAll():Observable<BaseDto[]>
  {
    return  this.http.get<BaseDto[]>("/api/TiposPropiedad/GetAll");
  }

  getById(id:number):Observable<BaseDto>
  {
    return  this.http.get<BaseDto>("/api/TiposPropiedad/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/TipoMoneda/Delete?id=" + id);
    else
      return of(null)
  }
}
